/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-input-group[type='filter'] > nve-select::part(_caret) {
  display: none !important;
}

nve-input-group > [nve-control],
nve-input-group > nve-button {
  --border-radius: 0;
}

nve-input-group[type='filter'] [nve-control]:nth-child(odd),
nve-input-group[type='filter'] nve-button:nth-child(odd) {
  --font-weight: var(--nve-ref-font-weight-medium);
  --text-align: center;
}
